
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/help/terms",
      function () {
        return require("private-next-pages/help/terms.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/help/terms"])
      });
    }
  